import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccountPrivacyState {
  postsReelsByLocation: boolean;
}

const initialState: AccountPrivacyState = {
  postsReelsByLocation: false,
};

const AccountPrivacySlice = createSlice({
  name: 'accountPrivacy',
  initialState,
  reducers: {
    setPostsReelsByLocation: (state, action: PayloadAction<boolean>) => {
      state.postsReelsByLocation = action.payload;
    },
    togglePostsReelsByLocation: (state) => {
      state.postsReelsByLocation = !state.postsReelsByLocation;
    },
  },
});

export const { setPostsReelsByLocation, togglePostsReelsByLocation } =
  AccountPrivacySlice.actions;
export default AccountPrivacySlice.reducer;
